"use strict";
// DEPRECATION NOTICE: Please also update InteractionWithValidatedAttachmentsV2 (Timeline Redesign https://git.hubteam.com/HubSpot/CRM-Issues/issues/28)
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _react = _interopRequireWildcard(require("react"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _UIAlert = _interopRequireDefault(require("UIComponents/alert/UIAlert"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _SharedDragDropContext = _interopRequireDefault(require("customer-data-ui-utilities/dnd/SharedDragDropContext"));

var _Attachments = require("customer-data-email/schema/attachments/Attachments");

var _AttachmentsList = _interopRequireDefault(require("customer-data-email/components/attachments/AttachmentsList"));

var _PassthruRtePlugins = _interopRequireDefault(require("customer-data-communicator/lib/draftjs/config/PassthruRtePlugins"));

var _InteractionWithValidatedAttachmentsComponentConfig = _interopRequireDefault(require("./config/InteractionWithValidatedAttachmentsComponentConfig"));

var _FileDrop = _interopRequireDefault(require("draft-plugins/plugins/FileDrop"));

var _Alerts = require("customer-data-ui-utilities/alerts/Alerts");

var _reactDndHtml5Backend = require("react-dnd-html5-backend");

var _reactDnd = require("react-dnd");

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _reactImmutableProptypes = require("react-immutable-proptypes");

var _filterNot = _interopRequireDefault(require("transmute/filterNot"));

var _loggers = require("customer-data-tracking/loggers");

var configuredDropTarget = (0, _reactDnd.DropTarget)(_reactDndHtml5Backend.NativeTypes.FILE, {
  drop: function drop(props, monitor) {
    return {
      files: monitor.getItem().files
    };
  }
}, function (dndConnect, monitor) {
  return {
    connectDropTarget: dndConnect.dropTarget(),
    isHovered: monitor.isOver()
  };
}); // Adds attachment support to an interaction component.  Attachments can be added or removed.  The list of added attachments
// is displayed below the interaction.
//
// This wrapper accepts attachment validators from its component config to perform interaction type specific validation of
// attached files.  The default is no validation.  All attachment and single attachment file validators may be provided.
//
//   validators = {
//     all: attachments => false || 'error.key',
//     file: (file, attachments) => List{['error.key'],
//   }
//
// Default behavior is no validation.
//
// An "attachmentsValid" prop is added to the InteractionComponent indicating the result of running validators.all().

var propTypes = {
  attachments: _react.PropTypes.instanceOf(_immutable.List).isRequired,
  children: _react.PropTypes.node,
  gates: (0, _reactImmutableProptypes.setOf)(_react.PropTypes.string),
  passthruRtePlugins: _react.PropTypes.instanceOf(_PassthruRtePlugins.default).isRequired,
  handleResizeIframe: _react.PropTypes.func,
  handleUsageLogging: _react.PropTypes.func,
  onSave: _react.PropTypes.func,
  onAttachmentRemoved: _react.PropTypes.func,
  onAttachmentAdded: _react.PropTypes.func,
  engagementType: _react.PropTypes.string,
  threadId: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number])
};
var defaultProps = {
  passthruRtePlugins: new _PassthruRtePlugins.default(),
  handleResizeIframe: _emptyFunction.default,
  handleUsageLogging: _emptyFunction.default,
  onAttachmentAdded: _emptyFunction.default,
  onAttachmentRemoved: _emptyFunction.default
};
var fileUploadOptions = {
  enabled: true,
  tooltip: null
};

var tooltip = _react.default.createElement(_FormattedHTMLMessage.default, {
  message: "customerDataCommunicator.InteractionWithValidatedAttachments.tooltip"
});

var tooltipPlacement = 'top';
var EnableNewRichTextToolbar = 'CRM:EnableNewRichTextToolbar';

var _default = function _default() {
  var componentConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _InteractionWithValidatedAttachmentsComponentConfig.default;
  return function (InteractionComponent) {
    var InteractionWithValidatedAttachments =
    /*#__PURE__*/
    function (_Component) {
      (0, _inherits2.default)(InteractionWithValidatedAttachments, _Component);

      function InteractionWithValidatedAttachments(props) {
        var _this;

        (0, _classCallCheck2.default)(this, InteractionWithValidatedAttachments);
        _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(InteractionWithValidatedAttachments).call(this, props));
        (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
        _this.partial = (0, _ComponentMethods.makePartial)();
        _this.state = _this.createInitialState();
        return _this;
      }

      (0, _createClass2.default)(InteractionWithValidatedAttachments, [{
        key: "hasToolbarBeta",
        value: function hasToolbarBeta() {
          var gates = this.props.gates;
          return gates && gates.get(EnableNewRichTextToolbar);
        }
      }, {
        key: "createInitialState",
        value: function createInitialState() {
          var _this2 = this;

          var GenericPluginGroup = componentConfig.GenericPluginGroup,
              AttachmentPlugin = componentConfig.AttachmentPlugin,
              FileManagerAttachmentPlugin = componentConfig.FileManagerAttachmentPlugin,
              fileOptions = componentConfig.fileOptions;
          var query = {
            hidden: true
          };
          var hasToolbarBeta = this.hasToolbarBeta();
          var passthruRtePlugins = this.props.passthruRtePlugins;
          passthruRtePlugins = passthruRtePlugins.concatPlugins(GenericPluginGroup([FileManagerAttachmentPlugin({
            onAttachmentSelected: this.partial(this.handleAttachmentSelected, 'file manager'),
            fileOptions: fileOptions,
            onPluginOpenModal: function onPluginOpenModal() {
              _this2.props.handleResizeIframe('fullscreen');
            },
            onPluginCloseModal: function onPluginCloseModal() {
              _this2.props.handleResizeIframe('windowed');
            }
          }), AttachmentPlugin({
            onAttachmentUploadStarted: this.handleAttachmentUploadStarted,
            onAttachmentSelected: this.partial(this.handleAttachmentSelected, 'upload'),
            onAttachmentUploadFailed: this.handleAttachmentUploadFailed,
            fileOptions: fileOptions,
            getCurrentOptions: this.handleGetFileUploadOptions
          })], {
            icon: 'attach',
            inline: false,
            className: 'private-dropdown--list',
            tooltip: tooltip,
            tooltipPlacement: tooltipPlacement,
            onOpenPopover: componentConfig.onOpenPopover,
            hasToolbarBeta: hasToolbarBeta
          })).concatPluginComposers((0, _FileDrop.default)({
            fileOptions: {
              query: query
            },
            onNonImageUploadStarted: this.handleAttachmentUploadStarted,
            onNonImageUploadFailed: this.handleAttachmentUploadFailed,
            onDropNonImage: this.partial(this.handleAttachmentSelected, 'drag and drop')
          }));
          return {
            passthruRtePlugins: passthruRtePlugins,
            warning: false,
            attachmentsInProgress: (0, _immutable.List)(),
            attachments: this.props.attachments
          };
        }
      }, {
        key: "handleGetFileUploadOptions",
        value: function handleGetFileUploadOptions() {
          return fileUploadOptions;
        }
      }, {
        key: "validateFile",
        value: function validateFile(file) {
          var attachments = this.props.attachments;
          var validators = componentConfig.validators;
          var idx = attachments.findIndex(function (f) {
            return f.get('id') === file.get('id');
          });

          if (idx !== -1) {
            this.setState({
              warning: {
                key: 'customerDataCommunicator.Email.api.errors.DUPLICATE_ATTACHMENTS'
              }
            });
            return false;
          }

          var warning = (0, _Attachments.validateFile)(file) || validators.file(file);

          if (warning) {
            this.setState({
              warning: warning
            });
            return false;
          }

          return true;
        }
      }, {
        key: "handleSave",
        value: function handleSave(interactionRecord, engagement) {
          var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          var attachments = this.state.attachments;

          if (interactionRecord) {
            interactionRecord = interactionRecord.set('attachments', attachments);
          }

          if (engagement) {
            engagement = engagement.set('attachments', attachments);
          }

          this.setState({
            attachments: (0, _immutable.List)(),
            attachmentsInProgress: (0, _immutable.List)()
          });
          return this.props.onSave(interactionRecord, engagement, options);
        }
      }, {
        key: "handleRemoveAttachment",
        value: function handleRemoveAttachment(ids) {
          if (!_immutable.List.isList(ids)) {
            ids = (0, _immutable.List)([ids]);
          }

          var attachments = this.state.attachments;
          attachments = (0, _filterNot.default)(function (attachment) {
            return ids.contains(attachment.get('id'));
          }, attachments);
          this.setState({
            attachments: attachments,
            warning: false
          });
          this.props.onAttachmentRemoved(ids);
        }
      }, {
        key: "handleAddAttachment",
        value: function handleAddAttachment(attachment) {
          this.setState({
            attachments: this.state.attachments.push(attachment),
            warning: false
          });
          this.props.onAttachmentAdded(attachment);
        }
      }, {
        key: "handleAttachmentSelected",
        value: function handleAttachmentSelected(type, file) {
          if (!file || !file.get('id')) {
            return;
          }

          this.props.handleUsageLogging('addedAttachment', {
            subAction: type
          });
          var activity = (this.props.engagementType || 'unknown').toLowerCase();

          _loggers.CommunicatorLogger.log('communicator_fileInteraction', {
            action: 'insert file',
            activity: activity,
            channel: activity === 'call' ? 'outbound call' : activity,
            fileType: file.get('type'),
            fileSource: type === 'upload' ? type : 'attached',
            source: this.props.threadId ? 'inbox' : 'communicator'
          }); // Removed the successfully uploaded file from the attachmentsInProgress list


          var attachmentsInProgress = this.state.attachmentsInProgress;
          attachmentsInProgress = attachmentsInProgress.filter(function (attachment) {
            return !file.get('originalName') || file.get('originalName') !== attachment.get('name');
          });
          this.setState({
            attachmentsInProgress: attachmentsInProgress
          });

          if (this.validateFile(file)) {
            this.handleAddAttachment(file);
          }
        } // File Upload started

      }, {
        key: "handleAttachmentUploadStarted",
        value: function handleAttachmentUploadStarted(files) {
          var attachmentsInProgress = this.state.attachmentsInProgress;
          var filesToUpload = _immutable.List.isList(files) ? files : (0, _immutable.List)([files]);
          this.setState({
            attachmentsInProgress: attachmentsInProgress.concat(filesToUpload)
          });
        }
      }, {
        key: "handleAttachmentUploadFailed",
        value: function handleAttachmentUploadFailed(error, failedAttachment) {
          // Removed the successfully uploaded file from the attachmentsInProgress list
          var attachmentsInProgress = this.state.attachmentsInProgress;
          attachmentsInProgress = attachmentsInProgress.filter(function (attachment) {
            return !failedAttachment || failedAttachment.get('name') !== attachment.get('name');
          });
          this.setState({
            attachmentsInProgress: attachmentsInProgress
          });
          (0, _Alerts.addDanger)('customerDataCommunicator.InteractionWithValidatedAttachments.attachmentUploadFailed', {
            fileName: failedAttachment && failedAttachment.get('name')
          });
        }
      }, {
        key: "handleWarningClosed",
        value: function handleWarningClosed() {
          this.setState({
            warning: false
          });
        }
      }, {
        key: "renderWarning",
        value: function renderWarning() {
          var warning = this.state.warning;

          if (!warning) {
            return null;
          }

          return _react.default.createElement(_UIAlert.default, {
            className: "m-bottom-4",
            closeable: true,
            onClose: this.handleWarningClosed,
            type: "warning"
          }, _react.default.createElement(_FormattedHTMLMessage.default, {
            message: warning.key,
            options: warning.options
          }));
        }
      }, {
        key: "renderError",
        value: function renderError(error) {
          return _react.default.createElement(_FormattedHTMLMessage.default, {
            key: error.key,
            message: error.key,
            options: error.options
          });
        }
      }, {
        key: "renderErrors",
        value: function renderErrors(errors) {
          if (errors.isEmpty()) {
            return null;
          }

          return _react.default.createElement(_UIAlert.default, {
            className: "m-bottom-4",
            type: "danger"
          }, _react.default.createElement(_UIList.default, {
            styled: errors.size > 1
          }, errors.map(this.renderError)));
        }
      }, {
        key: "renderAttachmentList",
        value: function renderAttachmentList() {
          var thumbnailUrlConfig = componentConfig.thumbnailUrlConfig;
          var _this$state = this.state,
              attachmentsInProgress = _this$state.attachmentsInProgress,
              attachments = _this$state.attachments;
          return _react.default.createElement(_AttachmentsList.default, {
            attachments: attachments,
            attachmentsInProgress: attachmentsInProgress,
            hasInteractions: true,
            onAttachmentRemoved: this.handleRemoveAttachment,
            thumbnailUrlConfig: thumbnailUrlConfig
          });
        }
      }, {
        key: "renderAttachments",
        value: function renderAttachments(errors) {
          var _this$state2 = this.state,
              attachmentsInProgress = _this$state2.attachmentsInProgress,
              attachments = _this$state2.attachments;

          if (!attachments.size && !attachmentsInProgress.size) {
            return null;
          }

          return _react.default.createElement("div", {
            className: "attachments"
          }, this.renderWarning(), this.renderErrors(errors), this.renderAttachmentList());
        }
      }, {
        key: "render",
        value: function render() {
          var children = this.props.children;
          var _this$state3 = this.state,
              passthruRtePlugins = _this$state3.passthruRtePlugins,
              attachments = _this$state3.attachments;
          var validators = componentConfig.validators;
          var errors = validators.all(attachments);
          return _react.default.createElement(InteractionComponent, (0, _extends2.default)({}, this.props, {
            attachments: this.state.attachments,
            attachmentsValid: errors.isEmpty(),
            onSave: this.handleSave,
            passthruRtePlugins: passthruRtePlugins
          }), this.renderAttachments(errors), children);
        }
      }]);
      return InteractionWithValidatedAttachments;
    }(_react.Component);

    InteractionWithValidatedAttachments.propTypes = propTypes;
    InteractionWithValidatedAttachments.defaultProps = defaultProps;
    var dropTarget = configuredDropTarget(InteractionWithValidatedAttachments);
    return (0, _SharedDragDropContext.default)()(dropTarget);
  };
};

exports.default = _default;
module.exports = exports.default;